function saveMap() {
    this.commands.saveMap()
}

export default {
    'Ctrl+S': saveMap,
    'Meta+S': saveMap,
}
